import React from "react";
import { Col, Container, Row, Modal } from "react-bootstrap";
import "../stylesheets/Organization.scss";
import Navbar from "./Navbar";
import BackArrow from "../Assets/back-arrow.svg";
import { useHistory } from "react-router";

const Login = () => {
  const history = useHistory();

  return (
    <React.Fragment>
      <Navbar showSignup={false} />
      <Container fluid className="main-container">
        <Modal show={true} centered contentClassName="login-modal p-2">
          <Modal.Body className="pb-02">
            <Container>
              <Row>
                <Col xs={10} md={11} className="px-0">
                  <h4
                    style={{ color: "#FFFFFF", fontFamily: "JioType-Medium" }}
                  >
                    Join Organization
                  </h4>
                </Col>
              </Row>
              <Row>
                <Col xs={10} md={11} className="px-0">
                  <h4
                    style={{
                      marginTop: "25px",
                      color: "#FFFFFF",
                      fontFamily: "JioType-Medium",
                      fontSize: "0.9rem",
                    }}
                  >
                    Please contact the Admin of your organization to help you
                    add in the organization.
                  </h4>
                </Col>
              </Row>
            </Container>
          </Modal.Body>
          <p className="sub-title back">
            <span onClick={() => history.goBack()}>
              <p className="backBtn">
                <img
                  alt=""
                  style={{ marginTop: -3 }}
                  src={BackArrow}
                  height="12"
                  width="15"
                />
                {"Back"}
              </p>
            </span>
          </p>
        </Modal>
      </Container>
    </React.Fragment>
  );
};

export default Login;
